export type CerebroEnvironment = 'Dev' | 'QA' | 'Stage' | 'Production';

export function useEnvironment(): CerebroEnvironment {
	return process.env.REACT_APP_CEREBRO_ENVIRONMENT as CerebroEnvironment;
}
